//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from "store/constants";

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Lesson Plans by Book ------------------------
const lessonPlansByBookInitial = [];

export const lessonPlansByBook = (state = lessonPlansByBookInitial, action) => {
  switch (action.type) {
    case ActionTypes.lesson_plan.listLessonPlanByBookSuccess:
      return action.payload;
    case ActionTypes.lesson_plan.createOrUpdateLessonPlanSuccess:
      const existingIndex = state.findIndex(plan => plan.id === action.payload.id);
      if (existingIndex !== -1) {
        return state.map((plan, index) => 
          index === existingIndex ? { ...plan, ...action.payload } : plan
        );
      } else {
        return [...state, action.payload];
      }
    case ActionTypes.lesson_plan.deleteLessonPlanSuccess:
      return state.filter(plan => plan.id !== action.payload.id);
    default:
      return state;
  }
};

//  -- Lesson Plans by Book and User ------------------------
const lessonPlansByBookAndUserInitial = [];

export const lessonPlansByBookAndUser = (state = lessonPlansByBookAndUserInitial, action) => {
  switch (action.type) {
    case ActionTypes.lesson_plan.listLessonPlanByBookAndUserSuccess:
      return action.payload;
    case ActionTypes.lesson_plan.createOrUpdateLessonPlanSuccess:
      const existingUserIndex = state.findIndex(plan => plan.id === action.payload.id);
      if (existingUserIndex !== -1) {
        return state.map((plan, index) => 
          index === existingUserIndex ? { ...plan, ...action.payload } : plan
        );
      } else {
        return [...state, action.payload];
      }
    case ActionTypes.lesson_plan.deleteLessonPlanSuccess:
      return state.filter(plan => plan.id !== action.payload.id);
    default:
      return state;
  }
};
